import { Component, ViewChild } from '@angular/core';
import { IonicPage, Content, NavController, NavParams } from 'ionic-angular';
import { PopoverController, ActionSheetController, LoadingController, Searchbar } from 'ionic-angular';
import { PropertiesService } from '../../services/properties.service';
import { PropertiesStore } from '../../stores/properties.store';
import { ConfigStore } from '../../stores/config.store';
import { PropertiesPopover } from '../../components/popovers/properties.popover';
import { ResidentialPage } from '../residential/residential';

@Component({
  selector: 'page-properties',
  templateUrl: 'properties.html',
})
export class PropertiesPage {

    @ViewChild(Content) content: Content;
    @ViewChild('quickSearch') quickSearch: Searchbar;

    private showSearch: boolean = false;
    private searchText: string = '';
    private title: string = "";
    private segment: string = "list";
    private category: string = ""; 
    private sortBy: string = "data_aggiornamento";
    private sortOrder: string = "desc";    
    private sortOptions: any = {
        data_aggiornamento: "Data aggiornamento",
        data_inserimento: "Data inserimento",
        prezzo_vendita: "Prezzo vendita",
        prezzo_affitto: "Prezzo affitto",
        tipologia: "Tipologia",
        localita: "Località"
    };
    private filters: any = {
        showSales: true,
        showRentals: true,
        showSuspended: true,
        showHistoricized: false
    }    

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private service: PropertiesService,
        private store: PropertiesStore,
        private config: ConfigStore,
        private popoverCtrl: PopoverController,
        private actionSheetCtrl: ActionSheetController,
        private loadingCtrl: LoadingController) {

        // ToDo: l'inizializzazione della pagina è da riorganizzare **COMPLETAMENTE**
        this.title = (navParams.data.title) ? navParams.data.title : this.getTitleFromCategory(config.data.defaultCategory);
        this.category = (navParams.data.category) ? navParams.data.category : config.data.defaultCategory;

        /* if (this.store.isEmpty()) {

            store.category = this.category;
            store.orderBy = this.sortBy;
            store.sortOrder = this.sortOrder;
            store.showSales = this.config.data.defaultFilters.showSales;
            store.showRentals = this.config.data.defaultFilters.showRentals;
            store.showSuspended = this.config.data.defaultFilters.showSuspended;
            store.showHistoricized = this.config.data.defaultFilters.showHistoricized;

            this.store.load();

        } else {

            // ToDo: verificare possibile discordanza tra la categoria passata nei parametri e uno store precedentemente popolato

            // Recupera filtri e ordinamento precedentemente salvati nello store
            // this.category = store.category;
            this.sortBy = store.orderBy;
            this.sortOrder = store.sortOrder;
            this.filters.showSales = store.showSales;
            this.filters.showRentals = store.showRentals;
            this.filters.showSuspended = store.showSuspended;
            this.filters.showHistoricized = store.showHistoricized;
        } */
    }

    ionViewDidLoad() {
        // console.log('ionViewDidLoad Properties');

        if (this.store.isEmpty()) {

            this.store.category = this.category;
            this.store.orderBy = this.sortBy;
            this.store.sortOrder = this.sortOrder;
            this.store.showSales = this.config.data.defaultFilters.showSales;
            this.store.showRentals = this.config.data.defaultFilters.showRentals;
            this.store.showSuspended = this.config.data.defaultFilters.showSuspended;
            this.store.showHistoricized = this.config.data.defaultFilters.showHistoricized;

            this.store.load();

        } else {

            // ToDo: verificare possibile discordanza tra la categoria passata nei parametri e uno store precedentemente popolato

            // Recupera filtri e ordinamento precedentemente salvati nello store
            // this.category = store.category;
            this.sortBy = this.store.orderBy;
            this.sortOrder = this.store.sortOrder;
            this.filters.showSales = this.store.showSales;
            this.filters.showRentals = this.store.showRentals;
            this.filters.showSuspended = this.store.showSuspended;
            this.filters.showHistoricized = this.store.showHistoricized;
        } 
    }

    private getTitleFromCategory(category: string): string {

        switch (category) {
            case 'R': return 'Residenziali';
            case 'C': return 'Commerciali';
            case 'I': return 'Industriali';
            case 'T': return 'Terreni';
        
            default:
                return category;
        }
    }    

    private isSuspended(item: any) {

        // ToDo: separare il controllo dello stato "storicizzato"!!!
        return ('T' == item.Sospeso || 'T' == item.Storicizzato);
    }

    get sortLabel(): string {

        let label: string = this.sortOptions[this.sortBy];

        if ("desc" == this.sortOrder)
            label += " \u2193";
        else
            label += " \u2191";

        return label;
    }

    private onItemSelected(item: any) {
        // console.log('[PropertiesPage] onItemSelected | item:');
        // console.log(item);
        
        let navParams: any = { Id_Pratica: item.Id_Pratica, N_Pratica: item.N_Pratica };

        switch (this.category) {

            case 'R': this.navCtrl.push(ResidentialPage, navParams); break;            

           // ToDo: implementare l'apertura della scheda immobile per le altre categorie

            default:
                throw new Error('Categoria immobile non valida (' + this.category + ')');
        }
    }

    private onSortChange(item: any) {        

        /* this.store.refresh().then(() => {
            this.content.scrollToTop();           
        }); */
    }

    private onSortOrderChange() {

        if ("asc" == this.sortOrder)
            this.sortOrder = "desc";
        else
            this.sortOrder = "asc";

        this.store.sortOrder = this.sortOrder;

        if (this.store.isDirty()) {

            this.store.refresh().then(() => {
                this.content.scrollToTop();
            })
        }
    }

    private onNextPage(infiniteScroll) {

        this.store.nextPage().then(() => {

            infiniteScroll.complete();
        });
    }

    private onPresentPopover(event) {

        let popover = this.popoverCtrl.create(PropertiesPopover, {
            filters: this.filters,
            sortChangeCallback: () => { this.presentSortActionSheet(); }  // Note(Moris): l'utilizzo di una lambda-expression permette di mantenere un corretto riferimento a "this"
        });

        popover.onDidDismiss(() => {

            // ToDo: spostare l'aggiornamento dei filtri dello store in un metodo dedicato
            this.store.showSales = this.filters.showSales;
            this.store.showRentals = this.filters.showRentals;
            this.store.showSuspended = this.filters.showSuspended;
            this.store.showHistoricized = this.filters.showHistoricized;

            if (this.store.isDirty()) {

                this.store.refresh().then(() => {
                    this.content.scrollToTop();
                });
            }
        });

        popover.present({
            ev: event            
        });
    }

    private presentSortActionSheet() {

        let buttons = [];

        for (let key in this.sortOptions) {

            let button = {
                text: this.sortOptions[key],
                handler: () => {

                    // console.log('[Properties] actionSheetClick | item: ' + key);                    

                    this.sortBy = key;
                    this.store.orderBy = key;                    
                }
            }            

            buttons.push(button);
        }

        let actionSheet = this.actionSheetCtrl.create({
            title: 'Ordina per',
            buttons: buttons
        });
        actionSheet.present();
    }

    private onSearchButtonClick() {
        this.showSearch = true;

        // Note(Moris): il timeout è necessario per assicurare che "this.quickSearch" ottenga un riferimento alla search-bar appena attivata.
        //              Inizialmente infatti la search-bar è assente dalla vista mediante un'apposita direttiva *ngIf.
        setTimeout(() => {
            if (this.quickSearch)
                this.quickSearch.setFocus();

        }, 150);
    }

    private onSearch(event) {
        // console.log('[PropertiesPage] onSearch | event:');
        // console.log(event);
    }

    private onSearchItems(event) {

        // ToDo: controllare se conviene avviare la ricerca mentre l'utente digita i termini.

        // console.log('[PropertiesPage] onSearchItems | text:' + this.searchText);
    }

    private onSearchBlur(event) {

        if ('' == this.searchText)
            this.showSearch = false;

        this.store.query = this.searchText;
        this.store.page = 1;

        if (this.store.isDirty()) {

            this.store.refresh().then(() => {
                this.content.scrollToTop();
            });
        }
    }   

    private onSearchKeyEnter() {
        // console.log('[PropertiesPage] onSearchKeyEnter');
    } 
}



// WEBPACK FOOTER //
// ./src/pages/properties/properties.ts